var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comment-editor" }, [
    _c("div", { staticClass: "comments-wrap" }, [
      _c(
        "ul",
        {
          class: {
            "comment-thread": true,
            "has-comments": _vm.sortedComments.length > 0 ? true : false
          }
        },
        _vm._l(_vm.sortedComments, function(comment) {
          return _c("SocialPostComment", {
            key: comment.id,
            attrs: {
              socialPost: _vm.socialPost,
              comment: comment,
              commentField: _vm.commentField,
              namespace: _vm.namespace
            },
            on: { clickReply: _vm.replyToComment }
          })
        }),
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "comment-input-wrap" },
      [
        _c(
          "b-collapse",
          {
            staticClass: "reply-collapse",
            model: {
              value: _vm.showReply,
              callback: function($$v) {
                _vm.showReply = $$v
              },
              expression: "showReply"
            }
          },
          [
            _c("div", { staticClass: "reply-label" }, [
              _vm._v(
                _vm._s(_vm.replyComment.name) + " - " + _vm._s(_vm.replyDate)
              )
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "reply-text" }, [
              _vm._v(_vm._s(_vm.replyText))
            ]),
            _vm._v(" "),
            _c("i", {
              staticClass: "fas fa-times",
              on: { click: _vm.hideReply }
            })
          ]
        ),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.commentText,
              expression: "commentText"
            }
          ],
          ref: "commentInput",
          staticClass: "comment-input",
          attrs: {
            rows: "1",
            name: "comment-post-" + _vm.socialPost.id,
            placeholder: "Type a new message",
            disabled: _vm.commentDisabled
          },
          domProps: { value: _vm.commentText },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.commentText = $event.target.value
              },
              function($event) {
                return _vm.resizeInput($event.target)
              }
            ],
            keydown: [
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                if (
                  $event.ctrlKey ||
                  $event.shiftKey ||
                  $event.altKey ||
                  $event.metaKey
                ) {
                  return null
                }
                $event.preventDefault()
              },
              function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                if (!$event.shiftKey) {
                  return null
                }
                if ($event.ctrlKey || $event.altKey || $event.metaKey) {
                  return null
                }
                return _vm.newline.apply(null, arguments)
              }
            ],
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              if (
                $event.ctrlKey ||
                $event.shiftKey ||
                $event.altKey ||
                $event.metaKey
              ) {
                return null
              }
              return _vm.commentSubmitted.apply(null, arguments)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "comment-controls" },
          [
            _c(
              "b-button",
              {
                staticClass: "comment-button",
                attrs: {
                  id: "comment-post-" + _vm.socialPost.id,
                  disabled: _vm.commentButtonDisabled
                },
                on: { click: _vm.commentSubmitted }
              },
              [_c("i", { staticClass: "fas fa-paper-plane" })]
            ),
            _vm._v(" "),
            _c("emoji-picker", {
              staticClass: "emoji-picker-outer",
              attrs: { search: _vm.emojiSearch },
              on: { emoji: _vm.insertEmoji },
              scopedSlots: _vm._u([
                {
                  key: "emoji-invoker",
                  fn: function(ref) {
                    var clickEvent = ref.events.click
                    return _c(
                      "button",
                      {
                        staticClass: "emoji-invoker",
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return clickEvent.apply(null, arguments)
                          }
                        }
                      },
                      [_c("i", { staticClass: "far fa-smile" })]
                    )
                  }
                },
                {
                  key: "emoji-picker",
                  fn: function(ref) {
                    var emojis = ref.emojis
                    var insert = ref.insert
                    var display = ref.display
                    return _c("div", { staticClass: "emoji-picker" }, [
                      _c("div", { staticClass: "emoji-search-wrap" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.emojiSearch,
                              expression: "emojiSearch"
                            }
                          ],
                          attrs: { type: "text", placeholder: "Search Emoji" },
                          domProps: { value: _vm.emojiSearch },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.emojiSearch = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "emoji-list-wrap" },
                        _vm._l(emojis, function(emojiGroup, category) {
                          return _c(
                            "div",
                            { key: category, staticClass: "emoji-category" },
                            [
                              _c("h5", [_vm._v(_vm._s(category))]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "emoji-category-content" },
                                _vm._l(emojiGroup, function(emoji, emojiName) {
                                  return _c(
                                    "span",
                                    {
                                      key: emojiName,
                                      attrs: { title: emojiName },
                                      on: {
                                        click: function($event) {
                                          return _vm.insertEmoji(emoji)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(emoji))]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }